export const USER_ROLES = {
  company: 'Company',
  admin: 'Brokerage Admin',
  ceo: 'CEO',
  agent: 'Agent',
  centuryCompany: 'CenturyCompany',
  centuryAmin: 'CenturyAdmin',
};
